export default __webpack_public_path__ + "static/media/icon-calling.20ae8f07.gif";